import type { ComplexCollection, ComplexCollectionFilter } from 'bundles/browse-common/types/complexCollections';

export function initialComplexCollection(
  first: ComplexCollection,
  filters: ComplexCollectionFilter[]
): ComplexCollection[] {
  const rest: ComplexCollection[] = filters.slice(1).map((filter) => {
    return {
      __typename: 'Recommendation_Collection',
      id: filter.context.id,
      additionalInput: filter.context.additionalInput,
      description: filter.label,
    };
  });
  return [first, ...rest];
}
